export const ElementTypes = {
  IMAGE: 'image',
  TEXT: 'text',
  CAROUSEL: 'carousel',
};
